// web_common_source_GetResourceByResourceType 根据资源类型获取二三级权限

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址：http://192.168.0.15:8080/doc.html#/所有接口/resource-controller/GetResourceByResourceTypeUsingPOST

export default function web_common_source_GetResourceByResourceType(pParameter) {
  if (!pParameter) pParameter = {};

  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/common/source/GetResourceByResourceType'
  params.data = pParameter
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}

